class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tabsElement = this.querySelector('[data-tabs]');

    // Toggle product details tab visibility on desktop
    this.windowWidth = window.innerWidth;
    this.toggleVisibilityDetails();

    // Catch click on reviews
    const productInfoCol = document.querySelector('[data-product-info]');

    // Judge.me reviews badge clickable and opening reviews tab
    this.jdgmPrevBadge = productInfoCol.querySelector('.jdgm-preview-badge');
    if (this.jdgmPrevBadge) {
      this.jdgmPrevBadge.addEventListener('click', this.reviewClick.bind(this));
    }

    // Okendo reviews badge clickable and opening reviews tab
    this.okendoStarRating = productInfoCol.querySelector('[data-oke-star-rating]');
    this.okendoWidget = document.querySelector('[data-oke-widget]')
    if (this.okendoStarRating && this.okendoWidget) {
      this.okendoStarRating.addEventListener('click', this.reviewClick.bind(this));
    }

    // Catch click on read more link
    document.querySelector('[button-product-description]')?.addEventListener('click', this.readMoreClick.bind(this));

    // Catch click on desktop tab navigation
    this.tabsElement.querySelectorAll('[data-tabs-link]').forEach(link => link.addEventListener('click', this.linkClick.bind(this,event,link)));

    // Catch click on mobile tab navigation
    this.tabsElement.querySelectorAll('[data-tabs-mobile-link]').forEach(mobLink => mobLink.addEventListener('click', this.mobLinkClick.bind(this,event,mobLink)));

  }

  toggleVisibilityDetails() {
    const TabElelents = document.querySelectorAll('[data-tabs-link]');
    const firstTabElement = TabElelents[0];
    const TabElelentsContent = document.querySelectorAll('[data-tabs-content-pane]');
    const firstTabElelentsContent = TabElelentsContent[0];

    const TabElelentsMobile = document.querySelectorAll('[data-tabs-mobile-link="description"]');
    //Toggle product details tab visibility on desktop

    if (this.windowWidth >= 768) {
      if (firstTabElement && firstTabElelentsContent) {
        firstTabElement.classList.add('is-active');
        firstTabElelentsContent.classList.add('is-active');
      }
    } else {
      if (TabElelentsMobile && TabElelentsContent){
        TabElelentsMobile.forEach((TabElelentMobile) => {
          TabElelentMobile.classList.remove('is-active');
        });
        TabElelentsContent.forEach((TabElelentContent) => {
          TabElelentContent.classList.remove('is-active');
        });
      }
    }
  }

  reviewClick() {
    const title = 'reviews'

    // Close the active tab and open the clicked tab after that
    this.closeActiveTab(title);

    // Open the clicked tag link
    this.openTabNavLink(title);
    this.scrollIntoView();
  }

  readMoreClick() {
    const title = 'description'
    // Close the active tab and open the clicked tab after that
    this.closeActiveTab(title);

    // Open the clicked tag link
    this.openTabNavLink(title);
    this.scrollIntoView();
  }

  // mobile
  mobLinkClick(event,mobLink) {
    const title = mobLink.dataset.tabsMobileLink;
    // Only do something when the tab is not active
    if (!mobLink.classList.contains('is-active')) {
      // Close the active tab and open the clicked tab after that
      this.closeActiveTab(title);

      // Open the clicked tag link
      this.openTabNavLink(title);
      this.openTab(title);
    } else {
      // Close the active tab
      this.closeCurrentTab(title);
    }
  }

  // desktop
  linkClick(event,link) {
    const title = link.dataset.tabsLink;

    // Only do something when the tab is not active
    if (!link.classList.contains('is-active')) {

      // Close the active tab and open the clicked tab after that
      this.closeActiveTab(title);

      // Open the clicked tag link
      this.openTabNavLink(title);
    } else {
      // Close the active tab
      this.closeCurrentTab(title);
    }
  }

  closeActiveTab(title) {
    const activeTab = this.tabsElement.querySelector('.is-active');
    // If there is an active tab
    if (activeTab) {
      // Get title
      const activeTitle = activeTab.dataset.tabsLink;
      // Don't reopen self
      if (activeTitle === title) {
        return;
      }

      this.closeTab(activeTitle);
      this.closeTabNavLink(activeTitle);
    }

    this.openTab(title);
  }

  closeCurrentTab(title) {
    const activeTab = this.tabsElement.querySelector('.is-active');
    // If there is an active tab
    if (activeTab) {

      // Get title
      const activeTitle = activeTab.dataset.tabsLink;

      // Close current tab
      this.closeTab(activeTitle);
    }
  }

  closeTab(title) {
    // Close the tab and tab link content
    this.tab =  this.tabsElement.querySelector('[data-tabs-link="' + title + '"]');
    this.mobTab = this.tabsElement.querySelector('[data-tabs-mobile-link="' + title + '"]');
    this.tabContent = this.tabsElement.querySelector('[data-tabs-content-pane="' + title + '"]');
    if (this.tab) {
      this.tab.classList.remove('is-active');
      this.tabContent.classList.remove('is-active');
    }
    if (this.mobTab) {
      this.mobTab.classList.remove('is-active');
      this.tabContent.classList.remove('is-active');
    }
  }

  closeTabNavLink(title) {
    // Close the tab link in nav
    this.tab =  this.tabsElement.querySelector('[data-tabs-link="' + title + '"]');
    this.mobTab = this.tabsElement.querySelector('[data-tabs-mobile-link="' + title + '"]');
    if (this.tab) {
      this.tab.classList.remove('is-active');
    }
    if (this.mobTab) {
      this.mobTab.classList.remove('is-active');
    }
  }

  openTab(title) {
    // Open new tab and the tab content
    this.tabsElement.querySelector('[data-tabs-content-pane="' + title + '"]').classList.add('is-active');
    this.tabsElement.querySelector('[data-tabs-link="' + title + '"]').classList.add('is-active');
    this.tabsElement.querySelector('[data-tabs-mobile-link="' + title + '"]').classList.add('is-active');
  }

  openTabNavLink(title) {
    // Open new tab
    this.tabsElement.querySelector('[data-tabs-link="' + title + '"]').classList.add('is-active');
    this.tabsElement.querySelector('[data-tabs-mobile-link="' + title + '"]').classList.add('is-active');
  }
}
customElements.define('product-tabs', ProductTabs);
